import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TTaxDutiesApi } from './types';

export const taxDuties: TTaxDutiesApi = {
	getCountryVatRateList: (payload) =>
		http.post(endpoint.taxDuties.COUNTRY_VAT_RATE_LIST, payload).then((response) => response.data),
	syncCountryVatRates: () =>
		http.post(endpoint.taxDuties.COUNTRY_VAT_RATE_SYNC).then((response) => response.data),
	uploadCountryVatRates: (payload) =>
		http
			.post(endpoint.taxDuties.COUNTRY_VAT_RATE_UPLOAD, payload.formData)
			.then((response) => response.data),

	getNonEuCountryVatRateList: (payload) =>
		http
			.post(endpoint.taxDuties.COUNTRY_VAT_RATE_NON_EU_LIST, payload)
			.then((response) => response.data),
	getSupportedNonEuCountryList: () =>
		http.get(endpoint.taxDuties.SUPPORTED_NON_EU_COUNTRY_LIST).then((response) => response.data),

	getHs6pCodeList: (payload) =>
		http.post(endpoint.taxDuties.HS6P_CODE_LIST, payload).then((response) => response.data),

	getCustomsDutyRateList: (payload) =>
		http.post(endpoint.taxDuties.CUSTOMS_DUTY_RATE_LIST, payload).then((response) => response.data),

	getSpecialTerritoryList: (payload) =>
		http.post(endpoint.taxDuties.SPECIAL_TERRITORY_LIST, payload).then((response) => response.data),
	createSpecialTerritory: (payload) =>
		http
			.post(endpoint.taxDuties.SPECIAL_TERRITORY_CREATE, payload)
			.then((response) => response.data),
	updateSpecialTerritory: (payload) =>
		http
			.put(endpoint.taxDuties.SPECIAL_TERRITORY_UPDATE(payload.id), payload.body)
			.then((response) => response.data),

	getSpecialTerritoryPostalCodeList: (payload) =>
		http
			.post(endpoint.taxDuties.SPECIAL_TERRITORY_POSTAL_CODE_LIST, payload)
			.then((response) => response.data),
	createSpecialTerritoryPostalCode: (payload) =>
		http
			.post(endpoint.taxDuties.SPECIAL_TERRITORY_POSTAL_CODE_CREATE, payload)
			.then((response) => response.data),
	updateSpecialTerritoryPostalCode: (payload) =>
		http
			.put(endpoint.taxDuties.SPECIAL_TERRITORY_POSTAL_CODE_UPDATE(payload.id), payload.body)
			.then((response) => response.data),
};
